import { ApiAxiosInstance } from './apiAxiosInstance';
import { multiTransactionAxiosInstance } from './multiTransactionAxiosInstance';
import { reportsApiAxiosInstance } from './reportsApiAxiosInstance';

export function clearAuthenticationHeaders() {
  const authenticatedInstances = [
    ApiAxiosInstance,
    multiTransactionAxiosInstance,
    reportsApiAxiosInstance
  ];

  authenticatedInstances.forEach((instance) => {
    if (instance?.defaults?.headers) {
      if ('Authorization' in instance.defaults.headers) {
        delete instance.defaults.headers.Authorization;
      }
      
      if (instance.defaults.headers.common && 'Authorization' in instance.defaults.headers.common) {
        delete instance.defaults.headers.common.Authorization;
      }
    }
  });
  
}
